




















import { Vue, Component, Prop } from "vue-property-decorator";
import tasks from "@/store/modules/tasks";
import SmoothHeight from "@/components/smoothHeight.vue";

@Component({ components: { SmoothHeight } })
export default class AddTask extends Vue {
  @Prop() columnId!: number;
  @Prop() selectedColumnId!: number;
  @Prop() columnOrder!: number;
  @Prop() selectColumnId!: Function;

  newTask: string | null = null;

  createNewTask() {
    if (this.newTask && this.newTask.trim()) {
      tasks.createTask({ columnOrder: this.columnOrder, text: this.newTask });
      this.selectColumnId(null);
      this.newTask = null;
    }
  }

  closeCreateTaskInput() {
    this.selectColumnId(null);
    this.newTask = null;
  }
}
